import React from 'react';
import { Users, CheckCircle, Clock, Star, FileText, GraduationCap } from 'lucide-react';

const OnboardingAnalyticsPanel = ({ data, trends, detailed = false }) => {
  return (
    <div className="bg-card border border-border rounded-lg p-6">
      <div className="flex items-center justify-between mb-6">
        <div>
          <h2 className="text-xl font-bold text-foreground mb-1">Onboarding Analytics</h2>
          <p className="text-sm text-muted-foreground">Track time-to-productivity and new hire satisfaction</p>
        </div>
        <div className="p-3 bg-blue-500/10 rounded-lg">
          <Users className="w-6 h-6 text-blue-500" />
        </div>
      </div>
      {/* Key Metrics Grid */}
      <div className="grid grid-cols-2 md:grid-cols-3 gap-4 mb-6">
        <div className="p-4 bg-muted/50 rounded-lg">
          <div className="flex items-center gap-2 mb-2">
            <Users className="w-4 h-4 text-muted-foreground" />
            <span className="text-xs text-muted-foreground">Total Onboarded</span>
          </div>
          <p className="text-2xl font-bold text-foreground">{data?.totalOnboarded}</p>
        </div>
        <div className="p-4 bg-muted/50 rounded-lg">
          <div className="flex items-center gap-2 mb-2">
            <Clock className="w-4 h-4 text-muted-foreground" />
            <span className="text-xs text-muted-foreground">Avg Time</span>
          </div>
          <p className="text-2xl font-bold text-foreground">{data?.avgTimeToComplete}d</p>
        </div>
        <div className="p-4 bg-muted/50 rounded-lg">
          <div className="flex items-center gap-2 mb-2">
            <CheckCircle className="w-4 h-4 text-muted-foreground" />
            <span className="text-xs text-muted-foreground">Completion Rate</span>
          </div>
          <p className="text-2xl font-bold text-foreground">{data?.taskCompletionRate}%</p>
        </div>
      </div>
      {/* Detailed Metrics */}
      {detailed && (
        <div className="space-y-4 mb-6">
          <div className="flex items-center justify-between p-3 bg-muted/30 rounded-lg">
            <div className="flex items-center gap-3">
              <Star className="w-5 h-5 text-yellow-500" />
              <span className="text-sm font-medium text-foreground">New Hire Satisfaction</span>
            </div>
            <span className="text-lg font-bold text-foreground">{data?.newHireSatisfaction}/5.0</span>
          </div>
          <div className="flex items-center justify-between p-3 bg-muted/30 rounded-lg">
            <div className="flex items-center gap-3">
              <FileText className="w-5 h-5 text-blue-500" />
              <span className="text-sm font-medium text-foreground">Document Collection Rate</span>
            </div>
            <span className="text-lg font-bold text-foreground">{data?.documentCollectionRate}%</span>
          </div>
          <div className="flex items-center justify-between p-3 bg-muted/30 rounded-lg">
            <div className="flex items-center gap-3">
              <GraduationCap className="w-5 h-5 text-green-500" />
              <span className="text-sm font-medium text-foreground">Training Completion</span>
            </div>
            <span className="text-lg font-bold text-foreground">{data?.trainingCompletionRate}%</span>
          </div>
        </div>
      )}
      {/* Trend Chart */}
      {trends && (
        <div>
          <h3 className="text-sm font-semibold text-foreground mb-3">Onboarding Trend</h3>
          <div className="flex items-end justify-between gap-2 h-32">
            {trends?.map((item, index) => (
              <div key={index} className="flex-1 flex flex-col items-center gap-2">
                <div className="w-full bg-muted rounded-t-lg relative" style={{ height: '100%' }}>
                  <div
                    className="absolute bottom-0 w-full bg-blue-500 rounded-t-lg transition-all"
                    style={{ height: `${(item?.onboarding / 20) * 100}%` }}
                  ></div>
                </div>
                <span className="text-xs text-muted-foreground">{item?.month?.split(' ')?.[0]}</span>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default OnboardingAnalyticsPanel;